import PaymentType from '@/types/PaymentTypes';

export type WalletBalance = {
  availableBalance: number;
  totalBalance: number;
  lockedBalance: number;
  currency: string;
  countryCode: string;
  currencySymbol: string;
  dateMillis: number;
  availableBalanceUsd?: number;
};

export type BankAccountType =
  | 'VISTA'
  | 'ELECTRONIC'
  | 'LP_CLABE'
  | 'LP_CLABE_TR'
  | 'COBRE_CLABE'
  | 'LP_CCI'
  | 'LP_CCI_ALT'
  | 'CCLOUD_LOCAL'
  | 'CCLOUD_WIRE'
  | 'CCLOUD_ACH'
  | 'BRIDGE_WIRE'
  | 'BRIDGE_ACH'
  | 'BITSO_CLABE'
  | 'V_VISTA'
  | 'V_ELECTRONIC';

export interface BankAccounts {
  bankAccountNumber: string;
  bankAccountTypeCode: BankAccountType;
  defaultAccount: boolean;
  accountNumberType: string;
  routingCodeType: string;
  routingCode: string;
  bankName: string;
  bankAddress: string;
  bankCountry: string;
  documentType?: string;
  documentNumber?: string;
  whitelist?: boolean;
  paymentType?: string;
  accountHolderName?: string;
  bankPartnerName?: string;
}

type CompensationNumbers = {
  accountId: number;
  active: boolean;
  compensationNumber: string;
  compensationNumberId: number;
};

export const BANK_PARTNER_ACCOUNT_NAME = {
  BRIDGE: 'BRIDGE',
  BRIDGE_SC: 'BRIDGE_SC',
} as const;

export type BankPartnerAccountName =
  (typeof BANK_PARTNER_ACCOUNT_NAME)[keyof typeof BANK_PARTNER_ACCOUNT_NAME];

export const BANK_PARTNER_ACCOUNT_AVAILABILTY = {
  NOT_AVAILABLE: 'NOT_AVAILABLE',
  AVAILABLE: 'AVAILABLE',
  IN_PROGRESS: 'IN_PROGRESS',
  CREATED: 'CREATED',
} as const;

export type BankPartnerAccountAvailability =
  (typeof BANK_PARTNER_ACCOUNT_AVAILABILTY)[keyof typeof BANK_PARTNER_ACCOUNT_AVAILABILTY];

type BankPartnerAccountStatus = {
  bankPartnerName: BankPartnerAccountName | null;
  status: BankPartnerAccountAvailability | null;
};

export type WalletType = {
  walletId: number;
  createdDate: string;
  accountBranchName: string;
  currency: string;
  countryCode: string;
  flagCountryCode: string;
  isMainAccount: boolean;
  balance: WalletBalance;
  checkDataAccount: string;
  withdrawalAvailable: boolean;
  status?: string;
  accountNumber: number;
  bankAccountCode: BankAccountType | null;
  bankAccounts: BankAccounts[];
  routeId: number;
  compensationNumbers: CompensationNumbers[];
  /**
   * @deprecated bankPartnerAccountStatus está deprecado.
   * Usar bankPartnerAccountStatusList que contiene los estados de todos los partners (BRIDGE, BRIDGE_SC, etc.)
   */
  bankPartnerAccountStatus?: BankPartnerAccountStatus;
  bankPartnerAccountStatusList?: BankPartnerAccountStatus[];
  isRemunerating?: boolean;
};

export interface BankAccountInfo {
  id: string;
  label: string;
  value: string;
  canCopy?: boolean;
  individualCopy?: boolean;
  isCompensationAccount?: boolean;
  compensationId?: number;
  show?: boolean;
}

export interface AccountExplanationInfo {
  title: string;
  img?: string;
  modal?: string;
  modalImg?: string;
  modalDescription?: string;
  description: string;
}

export interface IDestinationContactWallet {
  accountBranch: string;
  accountId: number;
  accountType: string;
  countryCode: string;
  currencyCode: string;
  flagCountryCode: string;
  isClientMain: boolean;
  isCurrencyMain: boolean;
}

export interface InfoUserBankAccount {
  name: string;
  email: string;
  idNumber: string;
  idType: string;
}

export type AvailableWallets = {
  currency: string;
  routeId: number;
  payments: PaymentType;
};

export type WalletsByCountry = {
  code: string;
  availableWallets: AvailableWallets[];
};
